import { selectFromRouteTemplatesDto } from '../../models';

export default selectFromRouteTemplatesDto()
  .name
  .active
  .routeLimit
  .projectId
  .createdOn
  .constraints(c => c
    .capacity
    .startTime
    .endTime
    .startLocations(sl => sl.address.latitude.longitude.bestMatch.active)
    .endLocations(el => el.address.latitude.longitude.bestMatch.active)
    .tags(t => t.uuid.name))
  .toString();
